import isNil from 'lodash/isNil';
import { CommonProps, CommonReturnProps } from 'interfaces/apiFetch';
import { METHODS } from 'utils/api';

import useFetch from '../useFetch';
import ApplicationContext from 'contexts/ApplicationContext';
import { useContext } from 'react';

interface ValidateOtpReturn extends CommonReturnProps {
  validateOtp: (passcode: string) => void;
}

const useValidateOtp = (props?: CommonProps): ValidateOtpReturn => {
  const { leadId } = useContext(ApplicationContext);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSuccessCallback = (): void => {
    if (!isNil(props) && !isNil(props.onSuccessCallback)) {
      props.onSuccessCallback();
    }
  };

  const onFailCallback = (): void => {
    if (!isNil(props) && !isNil(props.onFailCallback)) {
      props.onFailCallback();
    }
  };

  const {
    isLoading,
    error,
    isSuccessful,
    isFailed,
    executeRequest
  } = useFetch({ onSuccessCallback, onFailCallback });

  const validateOtp = (passcode: string): void => {
    executeRequest({
      path: `/validate_otp`,
      method: METHODS.POST,
      shouldExecuteRequest: true,
      payload: { lead_id: leadId, passcode }
    });
  };

  return {
    isFailed,
    isLoading,
    isSuccessful,
    error,
    validateOtp
  };
};

export default useValidateOtp;
